module.exports = __webpack_public_path__ + "static/20-yard-dumpster-banner-8268a2d82c7095f90c8f0b57c008d321.jpg";